import {
  Col,
  Dropdown,
  MenuProps,
  message,
  Popover,
  Row,
  Space,
  theme,
} from 'antd';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance from '../../../../axios_instance';
import { BaseUrlGeneral } from '../../../../utils';
import { errorHandling } from '../../../../utils/helper';
import EmployeeThumbnail from '../employee-thumbnail';
import ClientEngagedModal from '../profile/client_engaged';
import styles from './styles.module.scss';

const StatusDivStyle: any = {
  full_time: {
    border: '1px solid #5A9500',
    textAlign: 'center',
    paddingTop: '5px',
    marginTop: '21px',
    wordWrap: 'break-word',
    marginRight: '10px',
  },
  part_time: {
    border: '1px solid #5A9500',
    textAlign: 'center',
    paddingTop: '5px',
    marginTop: '21px',
    wordWrap: 'break-word',
    marginRight: '10px',
  },
  inactive: {
    border: '1px solid #F7931E',
    textAlign: 'center',
    paddingTop: '5px',
    marginTop: '21px',
    wordWrap: 'break-word',
    marginRight: '10px',
  },
};

const StatusTextStyle: any = {
  full_time: {
    fontFamily: 'Roboto',
    color: '#5A9500',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '16px',
    marginBottom: '5px',
  },
  part_time: {
    fontFamily: 'Roboto',
    color: '#5A9500',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '16px',
    marginBottom: '5px',
  },
  inactive: {
    fontFamily: 'Roboto',
    color: '#F7931E',
    fontStyle: 'normal',
    fontWeight: 700,
    fontSize: '14px',
    lineHeight: '16px',
    marginBottom: '5px',
  },
};
const StatusTextMapping: any = {
  full_time: 'Active',
  part_time: 'Active',
  inactive: 'Inactive',
  delete: 'Deleted',
};
interface EmployeeProps {
  employee: {
    name: string;
    id: string;
    url: string;
    email: string;
    experience_year: number | null;
    experience_month: number | null;
    mobile: number | null;
    designation: {
      designation: string;
      designation_id: number;
    };
    profile_status: {
      id: number;
      name: string;
    };
    resource_engaged: {
      id: number;
      name: string;
    };
    skills: Array<{
      skill_id: number;
      skill_name: string;
      experience_year: number;
      level: number;
    }>;
    profile_picture_url: string;
  };
}

const items_s: MenuProps['items'] = [
  {
    label: 'View Profile',
    key: '1',
  },
  {
    label: 'View Resume',
    key: '2',
  },
];

const items: MenuProps['items'] = [
  {
    label: 'Active',
    key: '3',
  },
  {
    label: 'Inactive',
    key: '1',
  },
  {
    label: 'Delete',
    key: '2',
  },
  { label: 'Client Engaged', key: 4 },
];

const Employee: React.FC<EmployeeProps> = ({
  employee,
}: EmployeeProps): JSX.Element => {
  const navigation = useNavigate();
  const [errorMessage, setErrorMessage] = useState<any>({});
  const [addNew, setAddNew] = useState<boolean>(false);
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleMenuClick: MenuProps['onClick'] = (e) => {
    if (e.key === '1') {
      axiosInstance
        .post('/api/v1/admin/user-profiles/', {
          profile_status: 4,
          profile_id: employee.id,
        })
        .then((response) => {
          message.success(`user inactived successfully`);
          window.location.reload();
        })
        .catch((error) => {
          errorHandling(error, setErrorMessage);
        });
    } else if (e.key === '2') {
      axiosInstance
        .post('/api/v1/admin/user-profiles/', {
          profile_status: 3,
          profile_id: employee.id,
        })
        .then((response) => {
          message.success(`user deleted successfully`);
          window.location.reload();
        })
        .catch((error) => {
          errorHandling(error, setErrorMessage);
        });
    } else if (e.key === '3') {
      axiosInstance
        .post('/api/v1/admin/user-profiles/', {
          profile_status: 1,
          profile_id: employee.id,
        })
        .then((response) => {
          message.success(`user activated successfully`);
          window.location.reload();
        })
        .catch((error) => {
          errorHandling(error, setErrorMessage);
        });
    } else if (e.key === '4') {
      // axiosInstance
      //   .post('/api/v1/admin/user-profiles/', {
      //     profile_status: 1,
      //     profile_id: employee.id,
      //   })
      //   .then((response) => {
      //     message.success(`user activated successfully`);
      //     window.location.reload();
      //   })
      //   .catch((error) => {
      //     errorHandling(error, setErrorMessage);
      //   });
      setAddNew(true);
    }
  };
  const menuProps = {
    items,
    onClick: handleMenuClick,
  };

  return (
    <>
      <ClientEngagedModal
        isModalOpen={addNew}
        setIsModalOpen={setAddNew}
        empId={employee['id']}
        empName={employee['name']}
        resource_engaged={
          employee['resource_engaged']
            ? employee['resource_engaged']
            : { id: 3, name: 'not_engaged' }
        }
      />
      <Row className={styles.row}>
        <Col span={6}>
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => navigation('/admin/employee/' + employee['id'])}
          >
            <div style={{ marginTop: '15px' }}>
              <EmployeeThumbnail
                {...{
                  employeeName: employee['name'],
                  employeePic:
                    BaseUrlGeneral +
                    '/api/v1/' +
                    employee['profile_picture_url'] +
                    `?${Date.now()}`,
                  employeePhone: employee['mobile'],
                }}
              />
            </div>
          </div>
        </Col>
        <Col span={4}>
          <div
            style={{
              marginTop: '27px',
              wordWrap: 'break-word',
              marginRight: '10px',
            }}
          >
            <p className={styles.text}>
              {employee['designation']['designation']}
            </p>
          </div>
        </Col>
        <Col span={2}>
          <div
            style={{
              marginTop: '27px',
              wordWrap: 'break-word',
              marginRight: '10px',
            }}
          >
            <p className={styles.text}>
              {employee.experience_year && employee.experience_year > 0 ? (
                <p className={styles.text}>
                  {employee.experience_year + '+ years'}
                </p>
              ) : (
                ''
              )}
            </p>
          </div>
        </Col>
        <Col span={2}>
          <div
            style={{
              marginTop: '27px',
              wordWrap: 'break-word',
              marginRight: '10px',
            }}
          >
            <p className={styles.text}>
              {employee['resource_engaged']['name'] == 'full_time' &&
                'Fully Engaged'}
              {employee['resource_engaged']['name'] == 'part_time' &&
                'Partially Engaged'}
              {employee['resource_engaged']['name'] == 'not_engaged' &&
                'Not Engaged'}
            </p>
          </div>
        </Col>
        <Col span={6} style={{ display: 'flex', alignItems: 'center' }}>
          <div
            style={{
              wordWrap: 'break-word',
              marginRight: '10px',
            }}
          >
            <p className={styles['skill-text']}>
              {employee['skills']
                .slice(0, 3)
                .map((skill: any, index: number) => {
                  return (
                    <Space className={styles['skill-box']} key={index}>
                      {skill['skill_name'] +
                        '(L:' +
                        skill['level'] +
                        ',E:' +
                        skill['experience_year'] +
                        ') '}
                    </Space>
                  );
                })}

              <Space style={{ cursor: 'pointer' }}>
                <Popover
                  placement="bottom"
                  title={'Skills'}
                  content={employee['skills'].map(
                    (skill: any, index: number) => {
                      return (
                        <Space className={styles['skill-box']} key={index}>
                          {skill['skill_name'] +
                            '(L:' +
                            skill['level'] +
                            ',E:' +
                            skill['experience_year'] +
                            ') '}
                        </Space>
                      );
                    }
                  )}
                >
                  {employee['skills'].length > 3 ? '... View more' : ''}
                </Popover>
              </Space>
            </p>
          </div>
        </Col>
        <Col span={3}>
          <div style={StatusDivStyle[employee['profile_status']['name']]}>
            <p style={StatusTextStyle[employee['profile_status']['name']]}>
              {StatusTextMapping[employee['profile_status']['name']]}
            </p>
          </div>
        </Col>

        <Col span={1}>
          <div id={'dropdown'}>
            <Dropdown
              menu={menuProps}
              getPopupContainer={(): any => document.getElementById('dropdown')}
            >
              <div
                style={{
                  marginTop: '20px',
                  wordWrap: 'break-word',
                  marginRight: '20px',
                  cursor: 'pointer',
                  float: 'right',
                }}
              >
                <img src="/more_vert.png" />
              </div>
            </Dropdown>
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Employee;
